import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { TimelinePage } from '../pages/TimelinePage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/timeline' as any)({
  component: Timeline,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Timeline() {
  return (
    <MainLayout>
      <TimelinePage />
    </MainLayout>
  )
}
